export default __webpack_public_path__ + "static/media/gallery_03.5158fac1.jpg";